import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx", "skeletonCount"];
import React from 'react';
import { Skeleton, Stack, extendSX } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This is the Fallback component to render till the module is ready.
 */
export default function FallbackFormPatientFormJumpLogic(_ref) {
  var sx = _ref.sx,
    _ref$skeletonCount = _ref.skeletonCount,
    skeletonCount = _ref$skeletonCount === void 0 ? 3 : _ref$skeletonCount,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isSingleSkeleton = skeletonCount === 1;
  var skeletons = React.useMemo(function () {
    return Array.from({
      length: skeletonCount
    }, function (_, index) {
      return index;
    });
  }, [skeletonCount]);
  return /*#__PURE__*/_jsx(Stack, _extends({
    gap: 3,
    sx: extendSX(sx, {
      overflowY: 'auto',
      marginInline: 'auto'
    })
  }, rest, {
    children: skeletons.map(function (it, index) {
      return isSingleSkeleton ? /*#__PURE__*/_jsx(Skeleton, {
        variant: "rectangular",
        height: 190
      }, it) : /*#__PURE__*/_jsx(Skeleton, {
        variant: "rectangular",
        height: index === 0 ? 190 : 56
      }, it);
    })
  }));
}